import React from 'react'
import { Header } from 'Components/header'
import { TourStops } from 'Containers/tourStops'
import { ActionButtons } from 'Components/actionButtons'
import { LanguageSelector } from 'Components/languageSelector'
import { IntroVideo } from 'Components/introVideo'
import { AiSearch } from 'Containers/aiSearch'

export const VirtualTourContainer = () => {
  return (
    <>
      <Header />
      <ActionButtons />
      <LanguageSelector />
      <AiSearch />
      <IntroVideo />
      <TourStops />
    </>
  )
}
